import {useQuery} from "@apollo/client";
import {useContext, useState} from "react";
import {FiPlus} from "react-icons/fi";

import {ActionBarWrapper} from "@/components/actionBarWrapper/ActionBarWrapper.tsx";
import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {useDebouncedSearch} from "@/lib/hooks/useDebouncedSearch.ts";
import {GQL_STATUSPAGE_COMPONENTS, StatusPageComponentsListResponse} from "@/lib/queries/statuspages.ts";
import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";
import {StatusPageComponentGroupUpdateModal} from "@/pages/statuspages/tabs/components/componentGroupModal/StatusPageComponentGroupUpdateModal.tsx";
import {StatusPageComponentUpdateModal} from "@/pages/statuspages/tabs/components/componentModal/StatusPageComponentUpdateModal.tsx";
import {StatusPageComponentsTableV2} from "@/pages/statuspages/tabs/components/componentsTable/StatusPageComponentsTableV2.tsx";

export const StatusPageComponentsTab = () => {
  const {statusPage, componentStatuses} = useContext(StatusPageContext);

  const [showComponentUpdateModal, setShowComponentUpdateModal] = useState(false);
  const [showComponentGroupUpdateModal, setShowComponentGroupUpdateModal] = useState(false);

  const {search, searchDebounced, searchChanged} = useDebouncedSearch();

  const {data, previousData, loading} = useQuery<StatusPageComponentsListResponse>(GQL_STATUSPAGE_COMPONENTS, {
    variables: {
      statusPageId: statusPage.id,
      search: searchDebounced,
      excludeComponentsInGroups: true,
    },
  });

  const renderData = data?.response || previousData?.response;

  const componentsData = renderData ? {data: renderData.items, total: renderData.total} : {data: [], total: 0};

  return (
    <div className={"d-flex flex-column gap-3"}>
      <ActionBarWrapper
        left={
          <>
            <SearchInput value={search} onChange={searchChanged} variant="tableControlBar" />
          </>
        }
        right={
          <>
            <Button variant={"secondary"} onClick={() => setShowComponentGroupUpdateModal(true)}>
              <Icon icon={FiPlus} />
              Group
            </Button>
            <StatusPageComponentGroupUpdateModal
              show={showComponentGroupUpdateModal}
              setShow={setShowComponentGroupUpdateModal}
              statusPageID={statusPage.id}
              defaultComponents={statusPage.components}
            />
            <Button onClick={() => setShowComponentUpdateModal(true)}>
              <Icon icon={FiPlus} />
              Component
            </Button>
            <StatusPageComponentUpdateModal
              show={showComponentUpdateModal}
              setShow={setShowComponentUpdateModal}
              statusPageID={statusPage.id}
              title={"Create Component"}
              submitBtnText={"Create Component"}
              components={statusPage.components}
              componentStatuses={componentStatuses}
            />
          </>
        }
      />
      <div>
        <StatusPageComponentsTableV2
          componentStatuses={componentStatuses}
          data={componentsData}
          statusPageId={statusPage.id}
          isFiltered={!!searchDebounced}
          isLoading={loading}
        />
      </div>
    </div>
  );
};
